import styled from "@emotion/styled";
import { Z_INDICES } from "config/consts";
import { DeviceType, useDeviceType } from "hooks/useDeviceType";

export const heightAdjust = (deviceType: DeviceType) => {
  if (deviceType === DeviceType.Mobile) {
    return 78;
  } else if (deviceType === DeviceType.Tablet) {
    return 65;
  } else {
    return 50;
  }
};

export const NavbarContainer = styled.div(props => {
  const deviceType = useDeviceType();
  const isTablet = deviceType === DeviceType.Tablet;

  return {
    height: `calc(100dvh - ${heightAdjust(deviceType)}px);`,
    minHeight: 206,
    width: isTablet ? 80 : 206,
    position: "sticky",
    zIndex: Z_INDICES.NAV_BAR,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: "0px 36px 36px 0px",
    padding: isTablet ? "12px 12px 25px 12px" : 32,
    top: 0,
    fontWeight: props.theme.fontWeights["work-sans-0"],
    fontFamily: props.theme.fontFamilies.Primary,
  };
});
